<template>
  <div class="space-y-3">
    <div>
      <label class="block text-xs font-medium text-fg-secondary dark:text-fg-secondary-dark mb-1">Why are the lessons ending? *</label>
      <select v-model="model.category" :class="inputClass">
        <option value="" disabled>— pick a reason —</option>
        <option v-for="[key, label] in options" :key="key" :value="key">{{ label }}</option>
      </select>
    </div>
    <div v-if="model.category === 'break'">
      <label class="block text-xs font-medium text-fg-secondary dark:text-fg-secondary-dark mb-1">
        Remind me to check back around
        <span class="text-fg-faint dark:text-fg-faint-dark font-normal ml-1">(optional)</span>
      </label>
      <input v-model="model.follow_up_date" type="date" :min="tomorrowIso" :class="inputClass" />
    </div>
    <div v-if="model.category && model.category !== 'reschedule'">
      <label class="block text-xs font-medium text-fg-secondary dark:text-fg-secondary-dark mb-1">
        Note <span class="text-fg-faint dark:text-fg-faint-dark font-normal ml-1">(optional)</span>
      </label>
      <input v-model="model.note" type="text" :class="inputClass" />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { STOP_CATEGORIES } from '../../utils/stopReasons.js'

const props = defineProps({
  allowReschedule: { type: Boolean, default: false },
  allowBreak:      { type: Boolean, default: true },
})
// { category, note, follow_up_date } — see utils/stopReasons.js emptyStop()
const model = defineModel({ type: Object, required: true })

const options = computed(() => STOP_CATEGORIES.filter(([key]) =>
  (props.allowReschedule || key !== 'reschedule') && (props.allowBreak || key !== 'break')))

const tomorrow = new Date()
tomorrow.setDate(tomorrow.getDate() + 1)
const tomorrowIso = tomorrow.toISOString().slice(0, 10)

const inputClass = 'w-full px-3 py-2 text-sm rounded-lg border border-stroke dark:border-stroke-dark bg-surface dark:bg-surface-dark text-fg-base dark:text-fg-base-dark focus:outline-none focus:ring-2 focus:ring-blue-500'
</script>
